const SHY = String.fromCharCode(173); // символ мягкого переноса

export const PAGE_NAME        = `Сертификат персонифици${SHY}рованного финансиро${SHY}вания`;
export const DESCRIPTION_PAGE = 'Сертификат — это право ребенка обучаться по программам дополнительного образования за счет средств, выделенных государством. Сертификат представляет собой запись в электронном реестре.';
export const KEY_WORDS        = 'Сертификат, образование, дополнительное образование, дети, выбор';



// WEBPACK FOOTER //
// ./src/pages/pf-dod/const.js